import VueCqrs from '@cqrs/vue-component-cqrs';
import { RawCriterionWeight } from '@Criteria/Model';
import * as q from '@Criteria/Weights/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class CriteriaWeightsQueries extends VueCqrs
{
	runWeightsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildWeightsPageQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}

	runWeightsSetsByHierarchyIdQueryV1(workspaceId: number, criteriaHierarchyId: number)
	{
		const query = q.buildWeightsSetsByHierarchyIdQueryV1(workspaceId, criteriaHierarchyId);
		this.$query(query);
	}

	runWeightsSetEditorQueryV1(workspaceId: number, criteriaHierarchyId: number, criteriaWeightsSetId: number)
	{
		const query = q.buildWeightsSetEditorQueryV1(workspaceId, criteriaHierarchyId, criteriaWeightsSetId);
		this.$query(query);
	}

	runSurveyWeightsSetCreatorQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildSurveyWeightsSetCreatorQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runWeightsSetQueryV1(workspaceId: number, criteriaHierarchyId: number, criteriaWeightsSetId: number)
	{
		const query = q.buildWeightsSetQueryV1(workspaceId, criteriaHierarchyId, criteriaWeightsSetId);
		this.$query(query);
	}

	runNormalizedWeightsQueryV1(workspaceId: number, criteriaHierarchyId: number, weights: RawCriterionWeight[])
	{
		const query = q.buildNormalizedWeightsQueryV1(workspaceId, criteriaHierarchyId, weights);
		this.$query(query);
	}

	runWeightsSetDependenciesQueryV1(workspaceId: number, criteriaWeightsSetId: number)
	{
		const query = q.buildWeightsSetDependenciesQueryV1(workspaceId, criteriaWeightsSetId);
		this.$query(query);
	}

	runWeightsSetWeightsViewerQueryV1(workspaceId: number, projectId: number, weightsSetId: number)
	{
		const query = q.buildWeightsSetWeightsViewerQueryV1(workspaceId, projectId, weightsSetId);
		this.$query(query);
	}

	runSurveyWeightsViewerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildSurveyWeightsViewerQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runPanelistWeightsViewerQueryV1(workspaceId: number, projectId: number, evalModelId: number, projectUserId: number)
	{
		const query = q.buildPanelistWeightsViewerQueryV1(workspaceId, projectId, evalModelId, projectUserId);
		this.$query(query);
	}

	runSurveyWeightsComparerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildSurveyWeightsComparerQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runWeightsSetsComparerQueryV1(workspaceId: number, projectId: number, evalModelId: number, ids: number[])
	{
		const query = q.buildWeightsSetsComparerQueryV1(workspaceId, projectId, evalModelId, ids);
		this.$query(query);
	}
}